import { MODULE_KEYS_MAP, type ModuleKey } from "@/api/permissions/permissions.types";
import {
  IconAugmentedReality2,
  IconBox,
  IconBriefcase,
  IconBuilding,
  IconBuildingCommunity,
  IconBuildingEstate,
  IconCalendarEvent,
  IconCash,
  IconCashBanknote,
  IconChecklist,
  IconClipboardCheck,
  IconDeviceAnalytics,
  IconClockHour4,
  IconFileAnalytics,
  IconFileDescription,
  IconFileSearch,
  IconPlaylistAdd,
  IconPlugConnected,
  IconHome,
  IconMap2,
  IconMapPin,
  IconMessage2,
  IconSettings2,
  IconFolders,
  IconShieldLock,
  IconShoppingCart,
  IconUserCog,
  IconUserHexagon,
  IconUserSearch,
} from "@tabler/icons-react";

export const routeIconKeys = {
  w9Requests: "w9-requests",
  reactiveHireRequests: "reactive-hire-requests",
} as const;

type RouteIconKey = (typeof routeIconKeys)[keyof typeof routeIconKeys];

export const routeIconComponents: Record<
  ModuleKey | string,
  React.ComponentType<{ size?: number; color?: string }>
> = {
  [MODULE_KEYS_MAP.home]: IconHome,
  [MODULE_KEYS_MAP.myTasks]: IconChecklist,
  [MODULE_KEYS_MAP.reports]: IconFileAnalytics,
  [MODULE_KEYS_MAP.chat]: IconMessage2,
  [MODULE_KEYS_MAP.checkInOut]: IconClockHour4,
  [MODULE_KEYS_MAP.formBuilder]: IconPlaylistAdd,
  [MODULE_KEYS_MAP.dispatchQueue]: IconDeviceAnalytics,

  [MODULE_KEYS_MAP.spCalendar]: IconCalendarEvent,

  [MODULE_KEYS_MAP.entities]: IconBuilding,
  [MODULE_KEYS_MAP.clients]: IconBuildingCommunity,
  [MODULE_KEYS_MAP.locations]: IconMapPin,
  [MODULE_KEYS_MAP.serviceProviders]: IconUserHexagon,
  [routeIconKeys.w9Requests]: IconFileSearch,
  [routeIconKeys.reactiveHireRequests]: IconUserSearch,
  [MODULE_KEYS_MAP.workOrders]: IconBriefcase,
  [MODULE_KEYS_MAP.files]: IconFolders,

  [MODULE_KEYS_MAP.assets]: IconBox,
  [MODULE_KEYS_MAP.procurement]: IconShoppingCart,
  [MODULE_KEYS_MAP.proposals]: IconFileDescription,
  [MODULE_KEYS_MAP.fmIntegrations]: IconPlugConnected,

  [MODULE_KEYS_MAP.accountsPayable]: IconCashBanknote,
  [MODULE_KEYS_MAP.closeOut]: IconClipboardCheck,
  [MODULE_KEYS_MAP.accountsReceivable]: IconCash,

  [MODULE_KEYS_MAP.rolesPermissions]: IconShieldLock,
  [MODULE_KEYS_MAP.userManagement]: IconUserCog,
  [MODULE_KEYS_MAP.settings]: IconSettings2,

  // Extra keys for backend compatibility
  client: IconBuildingCommunity,
  "client.brands": IconBuildingEstate,
  "client.locations": IconMapPin,
  location: IconMapPin,
  visit: IconMap2,
  alignment: IconAugmentedReality2,
  entity: IconBuilding,
  service_providers: IconUserHexagon,
  w9_requests: IconFileSearch,
  work_order: IconBriefcase,
  user_management: IconUserCog,
  sp_calendar: IconCalendarEvent,
  spCalendar: IconCalendarEvent,
  schedule_management: IconCalendarEvent,
  proposal: IconFileDescription,
  accounts_payable: IconCashBanknote,
  close_out: IconClipboardCheck,
  accounts_receivable: IconCash,
  dispatch_queue: IconDeviceAnalytics,
};

export function getRouteIcon(
  key: ModuleKey | RouteIconKey,
  size = 18,
  color?: string,
): React.ReactNode | undefined {
  const IconComponent = routeIconComponents[key];
  if (!IconComponent) return undefined;
  return <IconComponent size={size} color={color} />;
}
